(ns bp-libs.design-system.components.progress
  "Namespace progress bars")

(defn continue-watching-bar
  "Component that displays a configurable progress bar 0%-100%"
  {:storybook {:width {:name         "Progress"
                       :type         {:name "number"}
                       :defaultValue 20
                       :control      {:type "number"}}}}
  [{:keys [width clickable? height class foreground-class]}]
  (let [progress (or width 0)
        progress-0-100 (min (max 0 progress) 100)]
    [:div {:class ["flex justify-center items-center"
                   (when clickable? "cursor-pointer")]}
     [:div {:class ["w-full bg-gray-400 rounded-full drop-shadow-lg"
                    (or height "h-[0.3rem]")
                    class]}
      [:div  {:class ["bg-primary-500 rounded-full"
                      (or height "h-[0.3rem]")
                      foreground-class]
              :style {:width (when (number? progress) (str progress-0-100 "%"))}}]]]))
